// extracted by mini-css-extract-plugin
export var black = "_2j-6";
export var brand = "_2j-1";
export var ddefault = "_2j-0";
export var error = "_2j-3";
export var gray = "_2j-2";
export var highContrast = "_2j-8";
export var outline = "_2j-7";
export var success = "_2j-5";
export var warning = "_2j-4";